<template>
  <div class="practices-filters">
    <v-text-field
      :value="value"
      class="bh-input-pill rounded-pill"
      color="accent"
      height="48px"
      append-icon="bhi-loupe"
      placeholder="Search for company"
      filled
      clearable
      hide-details
      @input="onInput('name', $event)"
      @click:clear="clearSearch"
      @click:append="runSearch"
      @keydown.enter="runSearch"
    ></v-text-field>
    <dialog-select
      v-if="isAdmin"
      name="status"
      :items="statusFilters"
      :value="1"
      placeholder="Status"
      customClass="filter"
      itemText="label"
      itemValue="value"
      @input="filterStatus"
    ></dialog-select>
  </div>
</template>
<script>
import { debounce } from '@/helpers/debounce'
import DialogSelect from '@/components/forms/DialogSelect'
export default {
  name: 'PracticesFilters',
  components: {
    DialogSelect,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    tmpValue: '',
    statusFilters: [
      { label: 'Active', value: 1 },
      { label: 'Active & Inactive', value: null },
    ],
  }),
  methods: {
    clearSearch() {
      this.tmpValue = ''
      this.$emit('search-on:clear')
    },
    runSearch() {
      if (this.tmpValue) this.$emit('search-run', this.tmpValue)
    },
    onInput(key, value) {
      this.tmpValue = value
      debounce(
        () => {
          this.$emit('search-on:input', { key, value })
        },
        1000,
        'PracticesFilters',
      )
    },
    filterStatus(status) {
      this.$emit('filter-active', status.value)
    },
  },
}
</script>
<style lang="scss">
.practices-filters {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  .dialog-select {
    align-self: flex-end;
    width: 200px;
  }
}
.bh-input-pill {
  margin: 0 8px !important;
  width: 264px;
  height: 48px !important;
  flex-grow: 0;
  .v-input__slot {
    align-items: center;
    height: 48px;
    min-height: 0 !important;
    background: $bh-gray--6 !important;
    &::before,
    &::after {
      content: '';
      display: none;
    }

    .v-input__append-inner {
      align-self: center;
      margin-top: 0 !important;
    }

    .v-icon {
      color: $bh-blue;
    }
  }
}
</style>
